var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEmailIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  className: "design-iconfont",
  viewBox: "0 0 42 42",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M6.136 7.046h28.379c1.936 0 3.523 1.547 3.547 3.442l-17.73 9.733L2.603 10.5c.017-1.903 1.592-3.454 3.532-3.454m-3.532 7.178-.016 17.21c0 1.916 1.596 3.483 3.548 3.483h28.379c1.952 0 3.547-1.567 3.547-3.483V14.216L20.75 23.494a.89.89 0 0 1-.85 0z"
})));
export default SvgEmailIcon;